export default __webpack_public_path__ + "assets/icon-question.0ced8e78.svg";